import React from 'react';
import PropTypes from 'prop-types';
import MovilIcon from 'assets/images/IndicadoresHome/Indicadores_Activos_Mov.svg';
import WebIcon from 'assets/images/IndicadoresHome/Indicadores_Activos_Web.svg';
import './ActiveUsersCard.scss';
import { Row, Col } from 'antd';

const ActiveUsersCard = ({ movilData, webData }) => {
  return (
    <Row>
      <Col span={6}>
        <div className="usu-activos-home">
          <span className="usu-activos-span-home">Usuarios activos</span>
        </div>
        <div className="usu-activos-card">
          <div className="casos-users">
            <div className="users-icon">
              <img className="image-icon" src={MovilIcon} alt="" />
              <div style={{ marginLeft: '2px' }}>{movilData?.nombre}</div>
            </div>
            <div className="counter-casos">{movilData?.resumen?.total}</div>
          </div>
          <div className="linea" />
          <div className="casos-users">
            <div className="users-icon">
              <img className="image-icon" src={WebIcon} alt="" />
              <div className="text-image">{webData.nombre}</div>
            </div>
            <div className="counter-casos">{webData?.resumen?.total}</div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ActiveUsersCard;

ActiveUsersCard.propTypes = {
  movilData: PropTypes.arrayOf({
    detalle: PropTypes.arrayOf({
      total: PropTypes.number.isRequired
    }).isRequired,
    nombre: PropTypes.string.isRequired,
    resumen: PropTypes.shape({
      total: PropTypes.number.isRequired
    }).isRequired
  }).isRequired,
  webData: PropTypes.arrayOf({
    detalle: PropTypes.arrayOf({
      total: PropTypes.number.isRequired
    }).isRequired,
    nombre: PropTypes.string.isRequired,
    resumen: PropTypes.shape({
      total: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

// ActiveUsersCard.defaultProps = {
//   movilData: null,
//   webData: null
// };
